import { Link } from 'react-router-dom';
import InlineCTA from './InlineCTA';

const faqList = [
  {
    question: '世界盃投注最低可以下多少錢？',
    answer: '台灣運彩的最低投注金額為每注 100 元，是最容易入門的管道。建議新手從最低投注額開始，先熟悉投注流程和盤口運作，等累積經驗後再逐步增加注碼。',
  },
  {
    question: '世界盃投注會被課稅嗎？',
    answer: '在台灣，透過台灣運彩投注的彩金，單注中獎金額超過新台幣 5,000 元時需扣繳 20% 所得稅（由運彩代扣）。建議保留所有投注與中獎紀錄。',
  },
  {
    question: '世界盃比賽可以場中投注嗎？',
    answer: '可以。世界盃的每場比賽都提供場中投注（也稱「走地」或「Live Betting」），可以在比賽進行中即時投注。場中投注的賠率會隨比賽進球、紅牌等事件即時變化。新手建議先觀看幾場比賽了解場中投注的運作方式，再嘗試小額場中投注。',
  },
  {
    question: '台灣可以合法投注世界盃嗎？',
    answer: '可以。台灣運彩是合法的國內投注管道，世界盃期間會開放相關投注盤口。境外網站在台經營屬違法，玩家下注也有刑法第 266 條風險，中獎不出金的糾紛更無從求償。',
  },
];

export default function WorldCup2026Beginner() {

  return (
    <div>
<article style={{ maxWidth: 800, margin: '0 auto', lineHeight: 1.8, color: '#e0e0e0' }}>
        <h1>第一次投注世界盃？2026 世足新手投注教學</h1>

        {/* ========== 導讀 ========== */}
        <p>
          2026 世界盃是史上最盛大的一屆——48 支球隊、104 場比賽、美加墨三國聯合主辦。如果你從來沒有投注過世界盃，但看著比賽轉播時總忍不住想「要是我壓這場就好了」，那麼這篇教學就是為你寫的。
        </p>
        <p>
          本文將從最基礎的概念開始，一步步帶你了解世界盃投注的完整流程：從認識合法投注管道、了解基本盤口類型、到下注前該做什麼功課、以及新手最容易犯的錯誤。讀完這篇，你就能自信地完成第一筆世界盃投注。如果想更深入了解投注策略和賠率分析，可以接著閱讀<Link to="/blog/world-cup-2026-guide">2026 世界盃投注完整指南</Link>。
        </p>
        <p>
          <strong>重要提醒：</strong>投注是娛樂活動，不是賺錢的方式。設定好你能承受的預算，享受世界盃帶來的刺激和樂趣就好。如果你或認識的人有賭博成癮問題，請撥打求助專線 <strong>衛福部安心專線 1925</strong>（全年無休），或前往<a href="https://165.npa.gov.tw" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>165 反詐騙諮詢專線</a>尋求協助。
        </p>

        {/* ========== 目錄 ========== */}
        <nav aria-label="文章目錄" style={{ background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.15)', borderRadius: 12, padding: '16px 20px', margin: '24px 0' }}>
          <p style={{ fontWeight: 700, marginBottom: 8, color: '#D4AF37' }}>本文目錄</p>
          <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 2 }}>
            <li><a href="#step-by-step">投注完整流程五步驟</a></li>
            <li><a href="#bet-types">新手必學的投注類型</a></li>
            <li><a href="#bankroll">資金管理入門</a></li>
            <li><a href="#homework">下注前該做的功課</a></li>
            <li><a href="#mistakes">常見新手錯誤</a></li>
            <li><a href="#full-sop">「開戶到下注」完整 5 步驟 SOP</a></li>
            <li><a href="#top-10-mistakes">新手 10 大錯誤逐一拆解</a></li>
            <li><a href="#learning-path">2026 世足 Q1–Q4 學習路徑（開賽前 4 週）</a></li>
            <li><a href="#first-bet">新手第一場該下哪一盤？實戰建議</a></li>
            <li><a href="#emergency-sop">我輸了怎麼辦？資金與心理急救 SOP</a></li>
            <li><a href="#faq">FAQ 常見問題</a></li>
          </ol>
        </nav>

        {/* ==================== 第 1 節 ==================== */}
        <h2 id="step-by-step">一、投注完整流程五步驟</h2>
        <p>
          第一次投注世界盃可能覺得很複雜，但其實流程非常簡單。按照以下五個步驟，你就能順利完成第一筆投注。
        </p>

        <h3>步驟 1：認識合法投注管道</h3>
        <p>
          台灣唯一的合法投注管道是台灣運彩：
        </p>
        <ul>
          <li><strong><a href="https://www.sportslottery.com.tw" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>台灣運彩</a>：</strong>最簡單的選擇。到各地運彩投注站或使用「運彩券」APP 就能下注。世界盃期間會開放所有比賽的投注盤口</li>
          <li><strong>境外網站：</strong>在台經營屬違法，玩家下注也有刑法第 266 條風險，出金糾紛無從求償，不建議使用</li>
        </ul>

        <h3>步驟 2：準備下注</h3>
        <p>
          台灣運彩不需要特別開戶，直接到投注站就能下注；若要用官方 APP 線上投注，需先註冊會員並完成實名驗證。建議第一次只下最低金額，熟悉流程後再決定是否增加。
        </p>

        <h3>步驟 3：了解盤口和賠率</h3>
        <p>
          進入投注頁面後，你會看到各場比賽的盤口和賠率。最基本的資訊包括：
        </p>
        <ul>
          <li><strong>對陣：</strong>哪兩支球隊比賽（如 巴西 vs 日本）</li>
          <li><strong>盤口類型：</strong>你要預測什麼（如 勝負、進球數等）</li>
          <li><strong>賠率：</strong>數字越大代表該結果越不被看好，但中獎金額也越高</li>
        </ul>
        <p>
          例如，巴西 vs 日本的勝負盤賠率為「巴西 1.50 / 平手 4.20 / 日本 6.00」，代表投注 100 元在巴西贏，中獎可獲得 150 元（本金 100 + 獲利 50）。
        </p>

        <h3>步驟 4：選擇投注項目並下注</h3>
        <p>
          選好你要投注的項目和金額，確認無誤後提交投注。注意：投注確認後通常無法取消，所以下注前請再三確認投注內容。
        </p>

        <h3>步驟 5：觀看比賽並等待結果</h3>
        <p>
          下注後就好好享受比賽吧！比賽結束後，運彩會依官方結果結算。中獎的彩券可到投注站兌領，線上會員則依規定撥付。
        </p>

        <InlineCTA />

        {/* ==================== 第 2 節 ==================== */}
        <h2 id="bet-types">二、新手必學的投注類型</h2>
        <p>
          世界盃的投注類型非常多，但新手只需要先掌握以下四種最基本的類型就夠了。
        </p>

        <h3>1. 勝負盤（1X2）</h3>
        <p>
          預測比賽結果：主隊贏（1）、平手（X）、客隊贏（2）。這是最直觀的投注方式。注意，世界盃中「主隊」通常是先列出的隊伍。足球比賽的平手機率約 25%，不要忽略這個選項。
        </p>

        <h3>2. 大小球（Over/Under）</h3>
        <p>
          預測比賽的總進球數是否超過（大）或低於（小）某個數字。最常見的盤口是 2.5 球——也就是說，如果你投「大 2.5」，比賽需要有 3 個或以上的進球你才算贏。這個投注不需要預測誰贏誰輸，只需要判斷比賽是否會有很多進球。
        </p>

        <h3>3. 讓分盤（亞洲盤）</h3>
        <p>
          強隊「讓」弱隊一定的分數，讓雙方站在更公平的起跑線上。例如巴西讓日本 1.5 球，代表巴西需要贏 2 球以上你才算投中。讓分盤的賠率通常接近 1.85-1.95，回報率較為穩定。
        </p>

        <h3>4. 冠軍盤</h3>
        <p>
          預測整屆世界盃的冠軍隊伍。這是最「長線」的投注，需要等到決賽結束才知道結果。優點是賠率通常很高（熱門隊伍 5-8 倍，黑馬可達 50 倍以上），缺點是等待時間長且變數極多。
        </p>

        <h3>新手投注類型選擇建議</h3>
        <table>
          <thead>
            <tr><th>投注類型</th><th>難度</th><th>新手友善度</th><th>建議</th></tr>
          </thead>
          <tbody>
            <tr><td>勝負盤</td><td>★★☆☆☆</td><td>最高</td><td>最推薦新手開始的投注類型</td></tr>
            <tr><td>大小球</td><td>★★☆☆☆</td><td>高</td><td>不需要猜贏家，只需判斷進球多寡</td></tr>
            <tr><td>讓分盤</td><td>★★★☆☆</td><td>中</td><td>需要判斷贏多少，難度略高</td></tr>
            <tr><td>冠軍盤</td><td>★★★★☆</td><td>中</td><td>小額娛樂性質即可，不建議重壓</td></tr>
          </tbody>
        </table>

        {/* ==================== 第 3 節 ==================== */}
        <h2 id="bankroll">三、資金管理入門</h2>
        <p>
          資金管理是投注中最重要、也是新手最容易忽略的環節。不管你的分析能力多強，沒有好的資金管理，最終結果都不會太好。
        </p>

        <h3>設定預算的三個原則</h3>
        <ol>
          <li><strong>只用「娛樂費」投注：</strong>把世界盃投注當作看電影或去KTV的娛樂支出，用你每月能承受損失的閒錢來投注。如果你每月的娛樂預算是 3,000 元，那就拿 3,000 元當作整屆世界盃的投注預算</li>
          <li><strong>設定總預算上限：</strong>在世界盃開始前就決定好總預算，一旦用完就停止投注。千萬不要「追加」預算試圖把輸掉的錢贏回來</li>
          <li><strong>單注不超過總預算的 10%：</strong>如果你的總預算是 3,000 元，每次投注不要超過 300 元。這樣即使連輸幾場，也不會馬上把預算花完</li>
        </ol>

        <h3>新手資金分配建議</h3>
        <table>
          <thead>
            <tr><th>預算規模</th><th>單注上限</th><th>投注策略</th></tr>
          </thead>
          <tbody>
            <tr><td>1,000 – 3,000 元</td><td>100 – 300 元</td><td>專注勝負盤和大小球，每天最多投注 1-2 場</td></tr>
            <tr><td>3,000 – 10,000 元</td><td>300 – 1,000 元</td><td>可嘗試讓分盤和串關，冠軍盤小額投注</td></tr>
            <tr><td>10,000 元以上</td><td>1,000 元以下</td><td>可分配 10% 到冠軍盤和射手王等長期盤口</td></tr>
          </tbody>
        </table>

        {/* ==================== 第 4 節 ==================== */}
        <h2 id="homework">四、下注前該做的功課</h2>
        <p>
          盲目下注和做過功課後的下注，結果可能天差地遠。以下是新手投注前應該做的基本功課。
        </p>

        <h3>必查資訊清單</h3>
        <ul>
          <li><strong>球隊近況：</strong>近 5-10 場比賽的戰績。連勝中的球隊通常士氣高昂，但也可能因為連勝被高估</li>
          <li><strong>傷兵名單：</strong>關鍵球員（如隊長、主力射手、門將）是否受傷缺陣。這是影響比賽結果的最大變數</li>
          <li><strong>歷史交鋒：</strong>兩隊過往的對戰紀錄可以提供參考，但國家隊的人員變動較大，歷史紀錄的參考價值有限</li>
          <li><strong>小組出線形勢：</strong>特別是小組賽末輪，兩隊的晉級需求會大幅影響比賽的激烈程度</li>
          <li><strong>天氣和場地：</strong>北美的夏季可能非常炎熱，對習慣溫帶氣候的歐洲球隊可能不利</li>
        </ul>

        <h3>推薦資訊來源</h3>
        <ul>
          <li>FIFA 官方網站（球隊資料和排名）</li>
          <li>Transfermarkt（球員傷病和市值資訊）</li>
          <li>WhoScored / FBref（比賽數據和球員統計）</li>
          <li>台灣運彩官網（國內盤口和賠率）</li>
          <li>各大體育新聞網站（最新消息和分析）</li>
        </ul>

        <InlineCTA />

        {/* ==================== 第 5 節 ==================== */}
        <h2 id="mistakes">五、常見新手錯誤</h2>
        <p>
          了解常見錯誤，就能避免走冤枉路。以下是新手最常犯的五個錯誤。
        </p>

        <h3>錯誤 1：追輸（Chasing Losses）</h3>
        <p>
          輸了之後加倍下注試圖「翻本」，是最危險的行為。每一場比賽都是獨立事件，你輸了前一場不代表下一場就會贏。解決方法：設定每日停損點，達到就停止投注，隔天再來。
        </p>

        <h3>錯誤 2：只投注支持的球隊</h3>
        <p>
          因為支持巴西就只投注巴西贏，這叫「主觀偏見」。你對某支球隊的感情不應該影響你的投注判斷。解決方法：投注前問自己「如果我不是這支球隊的球迷，我還會下這注嗎？」
        </p>

        <h3>錯誤 3：盲目串關</h3>
        <p>
          串關（多場比賽串在一起投注）看似賠率很高，但每多串一場，中獎機率就呈指數下降。串 4 場每場 60% 勝率的比賽，整體中獎機率只有 13%。新手建議以單場投注為主，最多串 2-3 場。
        </p>

        <h3>錯誤 4：忽略平手選項</h3>
        <p>
          新手往往只看「誰會贏」，忘記足球比賽有約 25% 的平手機率。特別是實力接近的淘汰賽（90 分鐘計算），平手是非常合理的結果。
        </p>

        <h3>錯誤 5：不做紀錄</h3>
        <p>
          不記錄自己的投注歷史，就無法分析什麼類型的投注勝率最高、什麼時候投注判斷最準。建議用手機記事本或 Excel 記錄每一筆投注：日期、比賽、投注類型、金額、賠率、結果。一屆世界盃下來，你會從這些數據中學到很多。
        </p>

        {/* ==================== 第 6 節：開戶到下注 SOP ==================== */}
        <h2 id="full-sop">六、「開戶到下注」完整 5 步驟 SOP</h2>
        <p>
          前面第一節介紹了投注的概念性流程，這一節將把整個過程拆得更細，從你決定要投注 2026 世足的那一刻起，到第一張下注單成功提交為止，每一個步驟都會列出具體操作、平均花費時間、常見卡關點、以及對應的解決方案。對新手來說，「開戶到下注」這條路線往往不是技術困難，而是因為某個小細節（例如 KYC 文件被退、入金額度被卡、選錯盤口）讓人放棄。把這份 SOP 印下來照著做，就能把 2026 世界盃投注的入門門檻降到最低。
        </p>

        <h3>Step 1：認識台灣運彩（預估時間 30–60 分鐘）</h3>
        <p>
          新手第一步應該先花一個下午認識台灣運彩，而不是看到廣告就註冊來路不明的網站。台灣唯一合法的世界盃投注管道是台灣運彩，建議先確認這四項：（1）2026 世足盤口種類（是否含冠軍、射手王、組別出線）、（2）每種盤口的結算規則（多數只算 90 分鐘 + 補時）、（3）最低投注金額（單注 100 元）、（4）中獎 5,000 元以上預扣 20% 所得稅。常見卡關：被「賠率最高」的境外網站廣告吸引而忽略合法性，中獎不出金是 2026 世界盃投注最大的詐騙地雷之一。
        </p>

        <h3>Step 2：決定實體或線上（預估時間 10–20 分鐘）</h3>
        <p>
          台灣運彩不需要線上註冊，去投注站買實體彩券即可下注；若想用官方 APP 投注，就要註冊會員。註冊時請使用本人真實資料並綁定本人銀行帳戶，中獎撥付時一定會被比對。密碼採用「英文大小寫＋數字＋符號」16 位以上，並開啟兩階段驗證（2FA）。常見卡關：在搜尋結果點到仿冒的「運彩官網」——請直接輸入官方網址或從官方 APP 商店下載。
        </p>

        <h3>Step 3：實名驗證（預估時間 1–48 小時）</h3>
        <p>
          台灣運彩線上會員需要完成實名驗證（KYC），標準流程是身分證比對加上本人銀行帳戶驗證。拍照三大要點：（1）四角完整不裁切、（2）光線均勻不反光、（3）證件文字清晰可讀。世界盃開賽前後註冊量爆增，審核可能變慢，建議在 2026 年 6 月 1 日前就完成驗證，避免 6 月 11 日揭幕戰當天才發現驗證沒過。提醒：官方不會用 LINE 或電話要你提供信用卡安全碼、簡訊驗證碼，遇到就是詐騙。
        </p>

        <h3>Step 4：設定預算（預估時間 5–30 分鐘）</h3>
        <p>
          下第一張單之前，先把整個賽期的預算寫下來，並拆成每日上限。新手第一次下注建議只用最低金額，先把投注流程跑一次。記得保留每一張彩券或線上投注紀錄（含序號、金額、時間），日後有爭議時是唯一憑證。也要提防「儲值送禮金」的境外網站廣告——這類禮金多半綁定 10–20 倍流水，本身就是常見的詐騙誘餌。
        </p>

        <h3>Step 5：下注（預估時間 3–5 分鐘）</h3>
        <p>
          完成前 4 步後，下注本身反而最簡單。流程：登入 → 進入「足球」分類 → 選「世界盃 2026」→ 找到要投注的場次 → 點擊賠率（例：法國 vs 摩洛哥，法國勝 1.45）→ 輸入投注金額 → 確認單據 → 提交。提交前一定要再三檢查三件事：球隊方向（主隊還客隊）、盤口類型（勝負還讓分）、金額位數（800 不要打成 8,000）。下注確認後不可取消，這是新手最常後悔的環節。建議第一次只下 100–200 元、只下單場、只下勝負盤，把整個流程跑完一次再考慮進階盤。完成後請打開<Link to="/tools/worldcup-kelly-calculator">世足凱利計算機</Link>記錄這筆投注，建立屬於自己的下注日誌，這是新手 2026 世界盃投注最重要的長期資產。
        </p>

        <InlineCTA />

        {/* ==================== 第 7 節：10 大錯誤 ==================== */}
        <h2 id="top-10-mistakes">七、「新手 10 大錯誤」逐一拆解</h2>
        <p>
          以下這 10 個錯誤是過去四屆世界盃（2010、2014、2018、2022）裡新手投注族群最常犯、也最容易把預算燒光的行為。我們把每一個錯誤拆成「為什麼會犯」與「怎麼修正」兩個維度，讓你在 2026 世足下注前先建立心智模型。每一條後面都附上參考的賠率情境，讓你看得到真實案例。
        </p>

        <h3>錯誤 1：把本金一次梭哈在西班牙奪冠（DraftKings +500、Bet365 +450）</h3>
        <p>
          原因：受媒體渲染「西班牙是最大熱門」影響，新手把整月預算押在單一冠軍盤。修正：冠軍盤是「長線中獎率約 15–18% 的高方差盤」，再強的熱門也不應佔總預算超過 5%。建議：1,000 元預算就配 50 元到西班牙、50 元到法國，剩下 900 元保留給小組賽單場投注。
        </p>

        <h3>錯誤 2：跟風投注 Mbappé 射手王（+600）就忘記 Haaland（+1400）</h3>
        <p>
          原因：「最熱門 = 最容易中」是新手最深的迷思。修正：射手王盤的期望值經常出現在中段，Haaland 挪威 8 戰外圍賽進 16 球已晉級 2026 世界盃，+1400 反而比 +600 的 Mbappé 性價比高。射手王是長線盤，新手請小額分散 3–4 個候選人。
        </p>

        <h3>錯誤 3：忽略「平手」這個 25% 機率事件</h3>
        <p>
          原因：直覺認為足球就是「誰會贏」。修正：實力接近的小組賽尾輪，平手機率可達 28–32%，賠率通常 3.40–4.20。下注前先看雙方近 5 戰交手紀錄，若有 2 場以上平手就應該把平手放進候選。
        </p>

        <h3>錯誤 4：4 串 1 看到 25 倍就下手</h3>
        <p>
          原因：高賠率刺激多巴胺。修正：4 串 1 假設每場勝率 60%，整體中獎機率僅 12.96%，期望值通常為負。新手建議單注或最多 2 串 1，若真要 4 串 1，金額不要超過單注上限的一半。詳細串關期望值請看<Link to="/blog/world-cup-2026-betting-strategy">2026 世足投注策略全解</Link>。
        </p>

        <h3>錯誤 5：賽前 3 小時才下注，賠率早已變動</h3>
        <p>
          原因：以為「越接近開賽資訊越完整」。修正：莊家在賽前 6 小時會持續微調賠率，新手看到的賠率往往是「市場修正後」的版本。建議在賽前 24–48 小時完成下注，能享有更高的原始賠率。例如某場巴西 1.50，賽前 6 小時可能掉到 1.42。
        </p>

        <h3>錯誤 6：用「直覺」下盤口而不查傷兵名單</h3>
        <p>
          原因：嫌查資料太麻煩。修正：傷兵是足球最大變數。例如 Yamal 在 2026 年 4 月大腿肌腱拉傷，直接讓西班牙從 +450 跌到 +500。下注前必查 Transfermarkt 與球隊官方公告。
        </p>

        <h3>錯誤 7：不看國際賠率就下注</h3>
        <p>
          原因：只看一家賠率。修正：以法國奪冠為例，DraftKings 開 +500（賠率 6.00）、Bet365 開 +800（賠率 9.00），不同莊家對同一結果的定價差很多。下注台灣運彩前先對照國際賠率，判斷這個盤口有沒有 value，是 2026 世界盃投注的基本功。
        </p>

        <h3>錯誤 8：相信「內線消息」或「假牌局」廣告</h3>
        <p>
          原因：FOMO 加上對 LINE 群組老師的信任。修正：世界盃沒有內線。任何號稱「保證命中」的群組都是詐騙，世界盃投注詐騙在台灣每年通報量都超過千件。遇到請打 <a href="https://165.npa.gov.tw" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>165 反詐騙專線</a>查證，並向衛福部<a href="https://dep.mohw.gov.tw" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>心理健康司</a>諮詢若有沉迷傾向。
        </p>

        <h3>錯誤 9：賺到第一筆就把全部本金再投回去</h3>
        <p>
          原因：心理上認為「贏的是莊家的錢」。修正：每一筆中獎金額都是「你的錢」，不是別人的。建議中獎後立刻提領 50%，剩下 50% 才繼續投注。完整資金分配框架請看<Link to="/blog/world-cup-2026-bankroll">世足資金管理指南</Link>。
        </p>

        <h3>錯誤 10：每一場世足比賽都要下注</h3>
        <p>
          原因：怕錯過任何刺激感。修正：2026 世足共 104 場比賽，全下注必輸無疑。新手目標應該是「每天最多 1–2 場、整屆世界盃投注不超過 30 場」。把多出來的時間用來研究下一場，而不是衝動下注。專業玩家的中獎率通常來自「不下注的紀律」而非「下注的勇氣」。
        </p>

        {/* ==================== 第 8 節：學習路徑 ==================== */}
        <h2 id="learning-path">八、2026 世足 Q1–Q4 學習路徑（開賽前 4 週）</h2>
        <p>
          開賽日 2026-06-11 揭幕戰（墨西哥城）。這份學習路徑把開賽前 4 週切成 4 個階段，每週設定具體任務，讓新手有節奏地完成 2026 世界盃投注準備。請把這 4 週當作「投注健身房」，每一週都讓自己離下注前的最佳狀態更近一點。
        </p>

        <h3>第 1 週：5/20 – 5/26 │ 認識基礎</h3>
        <p>
          本週任務聚焦在「弄懂規則」。每天花 30 分鐘做以下三件事：（1）看完本篇〈第一次投注世界盃〉以及<Link to="/blog/world-cup-2026-guide">2026 世界盃投注完整指南</Link>；（2）熟記四種基本盤口：勝負、大小、讓分、冠軍；（3）打開 <a href="https://www.espn.com" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>ESPN</a> 看 5 場 2022 世界盃精華影片，邊看邊對照賠率，建立「賠率—實戰」的直覺。本週結束時要能背出 5 大熱門隊賠率：西班牙 +500、法國 +500、英格蘭 +650、巴西 +800、阿根廷 +850。
        </p>

        <h3>第 2 週：5/27 – 6/2 │ 註冊與小額測試</h3>
        <p>
          這週要把「行政手續」全部完成。任務清單：（1）如要線上投注，完成台灣運彩官方 APP 會員註冊與實名驗證；（2）訂好整個賽期的預算；（3）下一筆「練手單」——例如友誼賽或歐冠決賽的小注，把整個下注流程跑過一次；（4）開始建立投注日誌（Google Sheet 或筆記 APP）。本週結束時你應該已經完成第一筆下注，知道下注介面長什麼樣子，並清楚兌獎流程。常見卡關：實名驗證退件，預留 2–3 天緩衝。
        </p>

        <h3>第 3 週：6/3 – 6/10 │ 分析與策略建立</h3>
        <p>
          開賽前最後一週，把焦點轉到「球隊分析」。任務清單：（1）詳讀 FIFA 公布的 48 隊終極名單；（2）研究分組情勢，特別是死亡之組（Group C 巴西-摩洛哥、Group K 葡萄牙-哥倫比亞、Group I 法國-挪威）；（3）使用<Link to="/tools/worldcup-kelly-calculator">世足凱利計算機</Link>練習計算下注比例；（4）擬定整屆世足的「總預算分配表」——例如小組賽 50%、16 強 25%、8 強以後 20%、冠軍與射手王盤 5%；（5）參考 <a href="https://www.bet365.com" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>Bet365</a> 的賠率變化追蹤主要熱門隊。本週結束時你應該已經有一份書面下注計畫，且不再依靠情緒下注。
        </p>

        <h3>第 4 週：6/11 起 │ 揭幕戰與實戰調整</h3>
        <p>
          世界盃開打。本週重點不再是學習，而是「執行與紀律」。任務清單：（1）嚴格依第 3 週的預算分配表執行；（2）每場下注後立刻寫日誌（時間、賽事、盤口、賠率、金額、結果）；（3）每 3 場比賽結束做一次小檢討，看自己是否偏離計畫；（4）若連輸 3 場就強制暫停 24 小時。第 1 場揭幕戰墨西哥對某隊（Group A 熱門）是新手最容易衝動下注的時點，請特別克制。完成第 4 週你就已經是「有經驗的世足投注者」，後續可以挑戰更進階的盤口。
        </p>

        {/* ==================== 第 9 節：第一場下哪一盤 ==================== */}
        <h2 id="first-bet">九、新手第一場該下哪一盤？實戰建議</h2>
        <p>
          這是新手最常問的問題。答案是：第一場世界盃投注，請選「結果直觀、賠率合理、心理壓力低」的盤口。以下三種盤口是新手最適合的第一張下注單，並附上 2026 世足的具體賠率情境。
        </p>

        <h3>推薦 1：小組賽強隊讓分小球 1.5（賠率約 1.85–1.95）</h3>
        <p>
          以 Group C 巴西 vs 摩洛哥為例，巴西讓 1.5 球的賠率約 1.90。意思是巴西要贏 2 球以上你才中獎。為什麼推薦？因為（1）2026 世界盃小組賽強隊普遍能贏 1–2 球；（2）賠率接近 1:1，心理上「贏小錢」的接受度高；（3）即使輸了，看比賽過程也很有樂趣。預算建議：100–300 元，佔當日娛樂預算 10% 以內。
        </p>

        <h3>推薦 2：強弱對決的大盤 2.5（賠率約 1.70–1.85）</h3>
        <p>
          以法國 vs 約旦這類對戰為例，大 2.5 賠率約 1.75。為什麼推薦？因為（1）你不用猜誰贏，只要相信「兩隊加起來進 3 球以上」；（2）大盤的判斷依據相對單純——查兩隊近 5 場平均進失球即可；（3）足球大數據顯示，強弱對決進 3 球以上的機率超過 60%。預算建議：100–200 元。
        </p>

        <h3>推薦 3：實力接近的單純勝負盤（賠率 2.00–2.50）</h3>
        <p>
          以 Group I 法國 vs 挪威為例，法國勝 2.10、平手 3.40、挪威勝 3.50。為什麼推薦？因為這種勢均力敵的比賽會逼新手認真做功課，反而能學到最多。預算建議：先下 100 元，下注前列出 3 個你選法國（或挪威）的理由，這個動作會幫你建立分析習慣。
        </p>

        <h3>第一場下注的預算心法</h3>
        <p>
          無論你選哪一種盤口，第一場世界盃下注請遵守「一不二要」：（一）不要下超過總預算的 5%；（二）要把賠率寫進日誌、要在比賽結束後寫 100 字感想。新手投注 2026 世足的第一場意義在於「建立流程感」，不在於賺錢。把第一場當成繳學費，你會在後續 100 場比賽中得到回報。完整新手第一張下注單範例可參考<Link to="/blog/world-cup-2026-betting-strategy">世足投注策略全解</Link>裡的實戰章節。
        </p>

        {/* ==================== 第 10 節：輸了怎麼辦 ==================== */}
        <h2 id="emergency-sop">十、「我輸了怎麼辦？」資金與心理急救 SOP</h2>
        <p>
          連輸 3 場是每一個世界盃投注新手都會遇到的狀況——機率上幾乎不可避免（即使勝率 60%，連輸 3 場的機率仍有 6.4%）。重點不在「會不會發生」，而在「發生時怎麼處理」。下面這份急救 SOP 請印下來貼在手機桌布。
        </p>

        <h3>第 0 步：立即停止下注（強制 24 小時冷靜期）</h3>
        <p>
          連輸 3 場後最危險的不是錢，是大腦的「翻本衝動」。立即關掉投注 APP、把信用卡放到別的房間、設定投注上限或暫停使用投注 APP。這 24 小時不能看任何 2026 世足下注相關資訊，包含群組訊息與 YouTube 分析。
        </p>

        <h3>第 1 步：盤點剩餘預算（用紙筆寫，不要心算）</h3>
        <p>
          打開你的投注日誌，把剩餘預算寫在紙上。原則：剩餘 ≥ 50% 可繼續按原計畫，剩餘 30–50% 必須把單注上限砍半，剩餘低於 30% 應停止本屆世界盃投注、把剩餘金額留給娛樂。新手最常犯的錯就是「剩 10% 還想翻本」，這 10% 幾乎一定也會輸掉。
        </p>

        <h3>第 2 步：複盤 3 場輸的原因（每場寫 50 字）</h3>
        <p>
          打開日誌，逐場寫：（1）我當時為什麼選這個盤口？（2）資訊是否充分？（3）是不是情緒下注？多數新手會發現連輸 3 場裡有 1–2 場是「沒做功課就下注」。把這個發現寫進日誌，是最有價值的學費。
        </p>

        <h3>第 3 步：心理急救（找人聊、不要找群組）</h3>
        <p>
          連輸後的孤獨感很危險。建議：（1）跟家人或非賭博的朋友聊 30 分鐘，不必聊投注，聊任何事都好；（2）絕對不要去「翻本群組」找慰藉，那裡只會讓你下更大注；（3）若出現失眠、易怒、隱瞞家人金額等徵兆，請立即撥打安心專線 <strong>1925</strong> 或瀏覽<a href="https://dep.mohw.gov.tw" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>衛福部心理健康司</a>資源頁面。世界盃投注是娛樂，沒有任何一場比賽值得你的心理健康。
        </p>

        <h3>第 4 步：恢復下注前的「降規模重啟」</h3>
        <p>
          24 小時冷靜期結束後，若你決定繼續，請執行「降規模重啟」：單注金額減半、暫停所有讓分盤與串關、只下勝負盤與大小盤，連續中 3 場後才能恢復原本的下注規模。這個 SOP 是<Link to="/blog/world-cup-2026-bankroll">世足資金管理</Link>中最重要的反脆弱機制。
        </p>

        {/* ========== FAQ ========== */}
        <h2 id="faq">FAQ 常見問題</h2>
        {faqList.map((item, i) => (
          <details key={i} style={{ marginBottom: 12, padding: '8px 12px', background: 'rgba(255,255,255,0.03)', borderRadius: 8 }}>
            <summary style={{ cursor: 'pointer', fontWeight: 600 }}>{item.question}</summary>
            <p style={{ marginTop: 8 }}>{item.answer}</p>
          </details>
        ))}

        {/* ========== 延伸閱讀 ========== */}
        <nav aria-label="延伸閱讀" style={{ marginTop: 40, padding: '16px 20px', background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.15)', borderRadius: 12 }}>
          <p style={{ fontWeight: 700, color: '#D4AF37', marginBottom: 8 }}>延伸閱讀</p>
          <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 2.2 }}>
            <li><Link to="/blog/world-cup-2026-guide">2026 世界盃投注完整指南</Link></li>
            <li><Link to="/blog/world-cup-2026-odds">2026 世界盃賠率分析</Link></li>
            <li><Link to="/blog/sports-betting-guide">運彩完整指南</Link></li>
            <li>博弈新手完全指南</li>
          </ul>
        </nav>
      </article>
    </div>
  );
}
